import React from 'react';
import './PercentageInputField.css';

const PercentageInputField = ({title, value, setTo, locked=false, complete=null}) => {
    // Helper function to get validation class
    const getValidationClass = () => {
        if (complete === null) return '';
        if (complete === false) return 'incomplete';
        if (complete === true) return 'complete';
        return '';
    };

    // Helper function to get validation indicator
    const getValidationIndicator = () => {
        if (complete === null) return null;
        if (complete === false) return <span className='validation-indicator error'>*</span>;
        if (complete === true) return <span className='validation-indicator success'>✓</span>;
        return null;
    };

    return(
        <div className='percentage-input-field-container'>
            <div className='percentage-input-field-label'>
                {title}:
                {getValidationIndicator()}
            </div>
            <div className='percentage-input-field-wrapper'>
                <input 
                    className={`percentage-input-field-input ${getValidationClass()}`}
                    disabled={locked} 
                    value={value} 
                    onChange={e => setTo(e.target.value)}
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                />
                <div className='percentage-input-field-symbol'>%</div>
            </div>
        </div>
    );
};

export default PercentageInputField;
